module.exports = __webpack_public_path__ + "static/media/star_0FBB58.f0080c97.svg";